import Grid from '@mui/material/Grid';
import React from 'react';
import styled from '@emotion/styled';
import { TestId } from '@components/test-ids';
import { Result } from '@model/iceberg/deal-finder/deal-finder';
import { LoadMore } from './LoadMore';

export interface ResultsGridProps {
  packages: Array<Result>;
  isLoadingMore: boolean;
  isMoreAvailable: boolean;
  onLoadMore: () => void;
  renderTile: (productPackage: any) => JSX.Element;
}

const Container = styled(Grid)({
  height: '100%',
  minHeight: 300
});

export const ResultsGrid = ({ packages, isLoadingMore, isMoreAvailable, onLoadMore, renderTile }: ResultsGridProps) => {
  return (
    <Container container spacing={4} data-testid={TestId.dealFinder.results.container}>
      {packages.map((productPackage: Result, index) => (
        <Grid item key={productPackage.summary?.place?.hotel?.path || index} xs={12} sm={6} lg={4} xl={3}>
          {renderTile(productPackage)}
        </Grid>
      ))}
      <LoadMore isLoadingMore={isLoadingMore} onLoadMore={onLoadMore} isMoreAvailable={isMoreAvailable} />
    </Container>
  );
};
